import React from 'react';

const CaseStudies = ({ data }) => {
  return (
    <section className="p-80px-tb case-studies">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center m-50px-b">
            <h2 className="section-title font-weight-bold m-20px-b">{data.pageTitle}</h2>
            <p className="lead text-muted">{data.pageSubtitle}</p>
          </div>
        </div>

        <div className="row">
          {data.studies.map((study, index) => (
            <div key={index} className="col-lg-6 m-30px-b">
              <div className="case-study-card card h-100 shadow-sm hover-shadow transition">
                {/* 画像プレースホルダー */}
                <div className="case-image-placeholder bg-light p-50px text-center">
                  <i className="icofont-chart-growth icofont-5x text-primary"></i>
                  <p className="m-10px-t text-muted">導入事例イメージ</p>
                </div>

                <div className="card-body p-40px">
                  <h3 className="card-title font-weight-bold m-25px-b">{study.title}</h3>

                  <div className="case-details m-25px-b">
                    <div className="detail-item m-15px-b">
                      <h5 className="text-primary font-weight-bold">課題：</h5>
                      <p className="text-muted">{study.challenge}</p>
                    </div>

                    <div className="detail-item m-15px-b">
                      <h5 className="text-primary font-weight-bold">提案：</h5>
                      <p className="text-muted">{study.solution}</p>
                    </div>

                    <div className="detail-item m-15px-b">
                      <h5 className="text-primary font-weight-bold">成果：</h5>
                      <p className="text-muted">{study.result}</p>
                    </div>
                  </div>

                  <a href={study.url} className="btn btn-default btn-default-outline animated-btn">
                    詳細を見る <i className="icofont-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;